import { render, staticRenderFns } from "./OrganizationsPage.vue?vue&type=template&id=6b267d92&scoped=true&"
import script from "./OrganizationsPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsPage.vue?vue&type=style&index=0&id=6b267d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b267d92",
  null
  
)

export default component.exports